import React, { useEffect, useState, useContext, useRef, createRef } from 'react'
import { useHistory } from 'react-router-dom'
import AppContextObject from '../../common/context/common'
import MultiSelect from '../../components/formFields/multiSelect/multiSelect'
import config from '../../service/config'
import { findMonthsBetweenDate, objectDeepClone, validateCampaignName } from '../../service/helper'
import SimpleReactValidator from "simple-react-validator"
import errorSVG from "../../assets/images/error.svg"
import CustomDatePicker from '../../components/formFields/datePicker'
import moment from 'moment'
import TextField from '../../components/formFields/textField/textField'
import AddEventComponent from './addEventComponent'
import ThankyouModal from '../../components/addon/thankyouModal'
import ReCAPTCHA from "react-google-recaptcha";
// import "../../assets/css/addEvent.css"
const AddEventDataForm = () => {
    const [formValidator] = useState(useRef(new SimpleReactValidator({
        element: (message, className) =>
            <span className="valError"><img src={errorSVG} />{message}</span>
    })))
    const history = useHistory()
    const context = useContext(AppContextObject)
    const [schoolId, setSchoolId] = useState('')
    const [allEventList, setAllEventList] = useState([])
    const [customEventList, setCustomEventList] = useState([])
    const [schoolDetails, setSchoolDetails] = useState<any>({})
    const [venueList, setVenueList] = useState([])
    const [formErrors, setFormErrors] = useState<any>({})
    const [update, forceUpdate] = useState(false)
    const [eventRef, setEventRef] = useState([])
    const [customEventRef, setCustomEventRef] = useState([])
    const [showThankyouPopop, setShowThankyouPopop] = useState(false)
    const [timeoutId, setTimeoutId] = useState<any>(null)
    const [overlay, setOverlay] = useState(false)
    const [savingData, setSavingData] = useState(false)
    const [showCaptchaError, setShowCaptchaError] = useState(false)
    const [captchaVerified, setCaptchaVerified] = useState(false)
    const [defaultObj] = useState({
        name: "",
        custom: true,
        availableForBranding: true,
        venue: [],
        months: [],
        date: "31",
        attributes: [{
            name: "Stage Backdrop",
            availableForBranding: true,
            allowBrandsToProvide: true,
            _checked: false,
            images: [],
            count: 1,
            isSelected: false,
            isCustom: false,
            data: {
                quantity: 1,
                units: "feet",
                length: 6,
                height: 0,
                breadth: 4
            }
        },
        {
            name: "Stage Front",
            availableForBranding: true,
            allowBrandsToProvide: true,
            _checked: false,
            images: [],
            count: 1,
            isSelected: false,
            isCustom: false,
            data: {
                quantity: 1,
                units: "feet",
                length: 6,
                height: 0,
                breadth: 1,
            }
        },
        {
            name: "Stage Wings",
            availableForBranding: true,
            allowBrandsToProvide: true,
            _checked: false,
            images: [],
            count: 1,
            isSelected: false,
            isCustom: false,
            data: {
                quantity: 1,
                units: "feet",
                length: 2,
                height: 0,
                breadth: 6
            }
        },
        {
            name: "Stalls",
            availableForBranding: true,
            allowBrandsToProvide: true,
            _checked: false,
            images: [],
            count: 1,
            isSelected: false,
            isCustom: false,
            data: {
                quantity: 1,
                units: "feet",
                length: 6,
                height: 0,
                breadth: 4,
            }
        }],
        otherVenueList: []
    })

    useEffect(() => {
        let id = history.location.pathname.split(":")[1]
        console.log("history", history, id)
        setSchoolId(id)
        getEventList(id)
        let arr = []
        config.schoolAmenities.forEach(el => {
            // const found = arr.find(e => e.label === el.name)
            // if (!found) {
            arr.push({
                label: el.name,
                value: el.name
            })
            // }
        })
        arr.push({
            label: "Other",
            value: "Other"
        })
        setVenueList(arr)
    }, [])

    useEffect(() => {
        setEventRef(eventRef => (
            Array(allEventList.length).fill(0).map((_, i) => {
                return eventRef[i] || createRef()
            })
        ))
    }, [allEventList.length])
    useEffect(() => {
        setCustomEventRef(customEventRef => (
            Array(allEventList.length).fill(0).map((_, i) => {
                return customEventRef[i] || createRef()
            })
        ))
    }, [customEventList.length])
    const getEventList = async (id) => {
        let resp = await context.apis.public.getAllSchoolEventsExternal(
            context.validator, { school: id }, {}
        )
        console.log("getAllSchoolEventsExternal", resp)
        if (resp && resp.done) {
            console.log("getAllSchoolEventsExternal", resp)
            setSchoolDetails({ ...resp.response.school })
            let schoolEvents = [], schoolCustomEvents = []
            resp.response.schoolActivities && resp.response.schoolActivities.length > 0 && resp.response.schoolActivities.forEach((event, index) => {
                if (event.custom) {
                    event["startDate"] = event.startDate || ""
                    event["endDate"] = event.endDate || ""
                    schoolCustomEvents.push(event)
                }
                else {
                    event["startDate"] = event.startDate || ""
                    event["endDate"] = event.endDate || ""
                    schoolEvents.push(event)
                }
            })
            resp.response.masterActivities && resp.response.masterActivities.length > 0 && resp.response.masterActivities.forEach((event, index) => {
                if (!schoolEvents.find((item) => item.name === event.name)) {
                    event["venue"] = []
                    event["otherVenueList"] = []
                    event["isNew"] = true
                    event["months"] = []
                    event["startDate"] = ""
                    event["endDate"] = ""
                    event["custum"] = false
                    event["availableForBranding"] = true
                    // let attributes = event.placements
                    event["attributes"] = objectDeepClone(event.name.toLowerCase() === "parent teacher meetings" ? defaultObj.attributes.filter(attr => attr.name === "Stalls") : defaultObj.attributes)
                    delete event.placements
                    delete event._id
                    schoolEvents.push(event)
                }
            })
            setAllEventList([...schoolEvents])
            setCustomEventList([...schoolCustomEvents])
            console.log("getAllSchoolEventsExternal", resp, schoolEvents, schoolCustomEvents)
        }
    }
    const handleAddCustomEvent = (e) => {
        e.preventDefault()
        console.log("first", customEventList)
        let customDefaultObj = objectDeepClone(defaultObj)
        customDefaultObj.attributes.forEach(item => {
            item.isCustom = true
        })
        let newCustomEvent = objectDeepClone(customDefaultObj)
        newCustomEvent["isNew"] = true
        newCustomEvent["startDate"] = ""
        newCustomEvent["endDate"] = ""
        let customList = objectDeepClone(customEventList)
        customList.push(newCustomEvent)
        setCustomEventList([...customList])
    }
    // const removeCustomEvent = (index) => {
    //     let customList = objectDeepClone(customEventList)
    //     customList.splice(index, 1)
    //     setCustomEventList([...customList])
    // }
    // const onVenueChange = (data, index) => {
    //     let eventList = objectDeepClone(allEventList)
    //     let event = objectDeepClone(allEventList[index])
    //     event["venue"] = [...data.map(item => item.value)]
    //     eventList.splice(index, 1, event)
    //     setAllEventList([...eventList])
    //     console.log("multiselect", data, index)
    // }
    // const onCustumEventVenueChange = (data, index) => {
    //     let eventList = objectDeepClone(customEventList)
    //     let event = objectDeepClone(customEventList[index])
    //     event["venue"] = [...data.map(item => item.value)]
    //     eventList.splice(index, 1, event)
    //     setCustomEventList([...eventList])
    //     console.log("multiselect", data, index)
    // }
    // const onFormDataChange = (e, index) => {
    //     let eventList = objectDeepClone(allEventList)
    //     let event = objectDeepClone(allEventList[index])
    //     event[e.target.id] = e.target.value
    //     eventList.splice(index, 1, event)
    //     setAllEventList([...eventList])
    // }
    // const onCustomFormDataChange = (e, index) => {
    //     let eventList = objectDeepClone(customEventList)
    //     let event = objectDeepClone(customEventList[index])
    //     event[e.target.id] = e.target.value
    //     eventList.splice(index, 1, event)
    //     setCustomEventList([...eventList])
    // }
    const saveData = async (e) => {
        e.preventDefault()
        let eventValidation = [], customEventValidation = []
        eventRef && eventRef.length > 0 && eventRef.forEach((ref) => {
            if (ref.current && ref.current.validate) {
                eventValidation.push(ref.current.validate())
            }
        })
        customEventRef && customEventRef.length > 0 && customEventRef.forEach((ref) => {
            if (ref.current && ref.current.validate) {
                // ref.current.validate()
                customEventValidation.push(ref.current.validate())
            }
        })
        // const result = formValidator.current.allValid()
        // if (result === false) {
        //     formValidator.current.showMessages()
        //     forceUpdate(!update)
        //     return
        // }
        // else {
        //     formValidator.current.hideMessages()
        //     forceUpdate(!update)
        // }
        if (eventValidation.indexOf(false) !== -1 || customEventValidation.indexOf(false) !== -1 || captchaVerified === false) {
            setShowCaptchaError(true)
            return
        }
        let apiData = []
        allEventList && allEventList.forEach((item, index) => {
            if (item.venue && item.venue.length > 0 && item.startDate !== "" && item.endDate !== "") {
                let oldMonths = [...item.months]
                let newMonths = findMonthsBetweenDate(item.startDate, item.endDate)
                newMonths.forEach(el => {
                    if (!oldMonths.includes(el)) {
                        oldMonths.push(el)
                    }
                })
                item["months"] = [...oldMonths]
                apiData.push(item)
            }
        })
        customEventList && customEventList.length > 0 && customEventList.forEach((item, index) => {
            if (item.venue && item.venue.length > 0 && item.startDate !== "" && item.endDate !== "") {
                let oldMonths = [...item.months]
                let newMonths = findMonthsBetweenDate(item.startDate, item.endDate)
                newMonths.forEach(el => {
                    if (!oldMonths.includes(el)) {
                        oldMonths.push(el)
                    }
                })
                item["months"] = [...oldMonths]
                apiData.push(item)
            }
        })
        setSavingData(true)
        console.log("apiData", apiData)
        let resp = await context.apis.public.updateSchoolEventsExternal(
            context.validator, { school: schoolId, activities: apiData }
        )
        console.log("updateSchoolEventsExternal", resp)
        if (resp && resp.done) {
            setShowThankyouPopop(true)
            setOverlay(true)
        }
        setSavingData(false)
    }


    formValidator.current.rules['campaign_name'] = {
        message: 'Please enter valid name.',
        rule: (val) => {
            let returnValue = validateCampaignName(val)

            return returnValue
        },
    }
    const modalClose = () => {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        setShowThankyouPopop(false)
        setOverlay(false)
        history.push("/")
    }
    useEffect(() => {
        if (showThankyouPopop) {
            setTimeoutId(setTimeout(modalClose, 3000))
        }
    }, [showThankyouPopop])
    const onCaptchaSubmit = (value) => {
        if(value){
            setCaptchaVerified(true)
        }
    }
    const onCaptchaExpired = () => {
        setCaptchaVerified(false)
    }
    return (
        <div className="col-xs-12 col-lg-12 col-md-12 col-xs-12">
            <div className={`ovelap ${overlay === true ? "active" : ""}`}></div>
            <header className="headerLanding">
                <a href="" className="logo">
                    <img src="data:image/png;base64,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"
                        style={{ marginLeft: "100px" }}
                    />
                </a>
            </header>
            <div className="container" style={{ paddingTop: "60px" }}>

                <h2 style={{ textAlign: "center", fontSize: "22px", margin: "30px 0px" }}>{schoolDetails && schoolDetails.schoolName && schoolDetails.schoolName}</h2>

                <p style={{ textAlign: "center", fontWeight: "normal", margin: "30px 0px" }}>Add the venue and dates of your school’s events from the drop down menu or create your own custom event. 
                </p>
                <div className="col-xs-12 col-lg-12 col-md-12 col-xs-12 mb30" style={{marginLeft: "15px"}}>
                    <div className='row addEventHeader'>
                        <div className='col-xl-3 col-lg-3 col-md-3 col-xs-12'>Name</div>
                        <div className='col-xl-3 col-lg-3 col-md-3 col-xs-12'>Venue</div>
                        <div className="col-xl-1 col-lg-1 col-md-1 col-xs-12">&nbsp;</div>
                        <div className='col-xl-2 col-lg-2 col-md-2 col-xs-12'>Start Date</div>
                        <div className='col-xl-2 col-lg-2 col-md-2 col-xs-12'>End Date</div>
                    </div>
                </div>
                <div className="col-xs-12 col-lg-12 col-md-12 col-xs-12">
                    {allEventList && allEventList.length > 0 && allEventList.map((event, index) => (
                        <AddEventComponent
                            ref={eventRef[index]}
                            event={event}
                            index={index}
                            customEventList={allEventList}
                            setCustomEventList={setAllEventList}
                        />
                    ))}
                    <hr className="hr2" />
                    <p style={{margin: "25px 0 -15px 25px"}}>If an event/occasion is not listed already, you can click here to create and list a custom event with the required details. </p>
                    <button className="form-control col-md-2" style={{ cursor: "pointer", backgroundColor: "#666", color: "white", fontSize: "12px", fontWeight: "bold", margin: "25px",padding: "10px" }} onClick={handleAddCustomEvent}>
                        Add Custom event
                    </button>
                    {customEventList && customEventList.length > 0 && customEventList.map((event, index) => (
                        <AddEventComponent
                            ref={customEventRef[index]}
                            event={event}
                            index={index}
                            customEventList={customEventList}
                            setCustomEventList={setCustomEventList}
                            setOverlay={setOverlay}
                            overlay={overlay}
                        />
                    ))}
                    <hr className="hr2" />
                    <div style={{marginTop: "20px", display: 'flex', justifyContent: 'center'}}>
                        <ReCAPTCHA
                            sitekey="6LdwnoIhAAAAAKatIEo-5rYkRwzo1aMQFJw3cKT1"
                            onChange={onCaptchaSubmit}
                            onExpired={onCaptchaExpired}
                        />
                    </div>
                    {showCaptchaError && !captchaVerified &&
                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-10 end-xs' style={{display: 'flex', justifyContent: 'center'}}>
                            <div className="bottom-error-btn">
                                <p className="valError">
                                    <>
                                        <img src={errorSVG} />
                                        Please verify captcha.
                                    </>
                                </p>
                            </div>
                        </div>
                    }
                    <div style={{ padding: "20px", textAlign: "center", alignSelf: "center" }}>
                        <button className={`form-control col-md-3 btn btn-orange ${savingData && "btn-disabled"}`} style={{ fontSize: "18px" }} onClick={saveData}>Save Changes</button>
                    </div>
                </div>
            </div>
            <ThankyouModal
                showThankyouModal={showThankyouPopop}
                closeModal={modalClose}
                modalTitle="Thank You"
                description="Thank you for filling out the details!"
            />

        </div>
    )
}

export default AddEventDataForm